const PAST_LABEL = 'Past'

/** Text for a goal's "When" column. */
export const formatGoalWhen = ({ isPast, type, earliestYear, latestYear }) => {
  if (isPast) {
    return PAST_LABEL
  }

  // `type` is true for one-time goals; multiple disbursements can also fall
  // within the same year.
  if (type || earliestYear === latestYear) {
    return `${earliestYear}`
  }

  return `${earliestYear} - ${latestYear}`
}
